// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"82":"94412883","980":"49eb768a"}[chunkId] + ".chunk.css";
};